import {getImageAssetUrl} from '@/_application/core/utils/common';

export const productPlaceholder = getImageAssetUrl('placeholders/product.svg');
export const couponPlaceholder = getImageAssetUrl('placeholders/coupon.svg');
export const avatarPlaceholder = getImageAssetUrl('placeholders/avatar.svg');
export const logoPlaceholder = getImageAssetUrl('placeholders/logo.png');
